import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { DirectPlan, DirectSubscription } from '@app/modules/direct/models/direct-subscription.interface';
import { DirectSubscriptionService } from '@app/modules/direct/services/direct-subscription.service';
import {
  PayoutMethod,
  PayoutMethodProvider,
  PayoutMethodsService,
} from '@app/modules/direct/services/payout-methods.service';
import { ConfettiComponent } from '@app/ui/confetti/confetti.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-site-created',
  templateUrl: './dialog-site-created.component.html',
})
export class DialogSiteCreatedComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('confetti') confetti: ConfettiComponent;
  subscriptionStatus: DirectSubscription;
  payoutMethods?: PayoutMethod[];
  destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<DialogSiteCreatedComponent>,
    private directSubscription: DirectSubscriptionService,
    private payoutMethodsService: PayoutMethodsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.directSubscription.subscriptionStatus$.pipe(takeUntil(this.destroy$)).subscribe((subscription) => {
      this.subscriptionStatus = subscription;

      this.payoutMethodsService
        .fetchPayoutMethods(
          subscription.plan === DirectPlan.Premium ? PayoutMethodProvider.ADYEN : PayoutMethodProvider.STRIPE_OAUTH
        )
        .subscribe((methods) => (this.payoutMethods = methods));
    });
  }

  ngAfterViewInit(): void {
    this.confetti.makeItRain();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  addPayoutMethod() {
    this.dialogRef.close();

    if (this.subscriptionStatus.plan === DirectPlan.Premium) {
      this.router.navigate(['/direct/payouts/new/adyen']);
    } else {
      this.router.navigate(['/direct/payouts/new/stripe-oauth']);
    }
  }
}
